import axios from "axios";
import { UpdateUserMetadataResponse, UpdateUserMetadataRequest } from "redmond";
import { userMetadataPath } from "../paths";
import { config } from "../../config";

export const updateUserMetadata = (
  body: UpdateUserMetadataRequest
): Promise<UpdateUserMetadataResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(userMetadataPath, body, {
        baseURL: config.baseURL,
      });

      const responseBody: UpdateUserMetadataResponse = res.data;
      resolve(responseBody);
    } catch (e) {
      reject(e);
    }
  });
